import { IssueEntity, IssueType } from 'types/IssueEntity'

export const getIssueTypeLabel = (type: IssueType, earnout: IssueEntity['earnout']) => {
    switch (type) {
        case 'Rights issue':
            return 'Företrädesemission'
        case 'Directed issue':
            return 'Riktad emission'
        case 'Non-cash issue':
            if (earnout) {
                return 'Tilläggsköpeskilling'
            }
            return 'Apportemission'
        case 'IPO':
            return 'IPO'
        case 'Guarantor fee issue':
            return 'Garantieemission'
        case 'ABB Directed issue':
            return 'Accelererad bookbuilding'
        default:
            return type
    }
}
